module.exports = __webpack_public_path__ + "static/media/range_5_blue.890baec9.png";